/* tslint:disable */
/* eslint-disable */
/**
 * IAM Application API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface Pouzivatel
 */
export interface Pouzivatel {
    /**
     * 
     * @type {string}
     * @memberof Pouzivatel
     */
    'userId'?: string;
    /**
     * 
     * @type {string}
     * @memberof Pouzivatel
     */
    'meno'?: string;
    /**
     * 
     * @type {string}
     * @memberof Pouzivatel
     */
    'priezvisko'?: string;
    /**
     * 
     * @type {string}
     * @memberof Pouzivatel
     */
    'titulPred'?: string;
    /**
     * 
     * @type {string}
     * @memberof Pouzivatel
     */
    'titulZa'?: string;
    /**
     * 
     * @type {string}
     * @memberof Pouzivatel
     */
    'fullName'?: string;
    /**
     * 
     * @type {string}
     * @memberof Pouzivatel
     */
    'userUUID'?: string;
    /**
     * 
     * @type {string}
     * @memberof Pouzivatel
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof Pouzivatel
     */
    'nazovPozicie'?: string;
    /**
     * 
     * @type {string}
     * @memberof Pouzivatel
     */
    'poziciaVDative'?: string;
    /**
     * 
     * @type {string}
     * @memberof Pouzivatel
     */
    'poziciaVAkuzative'?: string;
}
/**
 * 
 * @export
 * @interface PouzivatelPage
 */
export interface PouzivatelPage {
    /**
     * 
     * @type {number}
     * @memberof PouzivatelPage
     */
    'totalCount'?: number;
    /**
     * 
     * @type {Array<Pouzivatel>}
     * @memberof PouzivatelPage
     */
    'results'?: Array<Pouzivatel>;
}

/**
 * PouzivatelApi - axios parameter creator
 * @export
 */
export const PouzivatelApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [userId] user id
         * @param {string} [userUUID] user uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPouzivatel: async (userId?: string, userUUID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/pouzivatelia`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (userUUID !== undefined) {
                localVarQueryParameter['userUUID'] = userUUID;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PouzivatelApi - functional programming interface
 * @export
 */
export const PouzivatelApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PouzivatelApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [userId] user id
         * @param {string} [userUUID] user uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPouzivatel(userId?: string, userUUID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Pouzivatel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPouzivatel(userId, userUUID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PouzivatelApi.getPouzivatel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PouzivatelApi - factory interface
 * @export
 */
export const PouzivatelApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PouzivatelApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [userId] user id
         * @param {string} [userUUID] user uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPouzivatel(userId?: string, userUUID?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<Pouzivatel>> {
            return localVarFp.getPouzivatel(userId, userUUID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PouzivatelApi - object-oriented interface
 * @export
 * @class PouzivatelApi
 * @extends {BaseAPI}
 */
export class PouzivatelApi extends BaseAPI {
    /**
     * 
     * @param {string} [userId] user id
     * @param {string} [userUUID] user uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PouzivatelApi
     */
    public getPouzivatel(userId?: string, userUUID?: string, options?: RawAxiosRequestConfig) {
        return PouzivatelApiFp(this.configuration).getPouzivatel(userId, userUUID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PouzivatelListApi - axios parameter creator
 * @export
 */
export const PouzivatelListApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [userUUID] user uuid
         * @param {string} [orgUUID] organization uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPouzivatelList: async (userUUID?: string, orgUUID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/organizacie/pouzivatelia`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userUUID !== undefined) {
                localVarQueryParameter['userUUID'] = userUUID;
            }

            if (orgUUID !== undefined) {
                localVarQueryParameter['orgUUID'] = orgUUID;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [orgUUID] organization uuid
         * @param {string} [roleId] role id
         * @param {string} [userFullNameContains] user search name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPouzivatelWithRoleList: async (orgUUID?: string, roleId?: string, userFullNameContains?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/opravnenia/pouzivatelia`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (orgUUID !== undefined) {
                localVarQueryParameter['orgUUID'] = orgUUID;
            }

            if (roleId !== undefined) {
                localVarQueryParameter['roleId'] = roleId;
            }

            if (userFullNameContains !== undefined) {
                localVarQueryParameter['userFullNameContains'] = userFullNameContains;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [userFullNameContains] user search name
         * @param {string} [orgUUID] organization uuid
         * @param {string} [userUUID] user uuid
         * @param {number} [size] size of returned data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getZodpovednyPredkladatelList: async (userFullNameContains?: string, orgUUID?: string, userUUID?: string, size?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/public/opravnenia/zodpovedny-predkladatel/pouzivatelia`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userFullNameContains !== undefined) {
                localVarQueryParameter['userFullNameContains'] = userFullNameContains;
            }

            if (orgUUID !== undefined) {
                localVarQueryParameter['orgUUID'] = orgUUID;
            }

            if (userUUID !== undefined) {
                localVarQueryParameter['userUUID'] = userUUID;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PouzivatelListApi - functional programming interface
 * @export
 */
export const PouzivatelListApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PouzivatelListApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [userUUID] user uuid
         * @param {string} [orgUUID] organization uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPouzivatelList(userUUID?: string, orgUUID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Pouzivatel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPouzivatelList(userUUID, orgUUID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PouzivatelListApi.getPouzivatelList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [orgUUID] organization uuid
         * @param {string} [roleId] role id
         * @param {string} [userFullNameContains] user search name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPouzivatelWithRoleList(orgUUID?: string, roleId?: string, userFullNameContains?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Pouzivatel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPouzivatelWithRoleList(orgUUID, roleId, userFullNameContains, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PouzivatelListApi.getPouzivatelWithRoleList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [userFullNameContains] user search name
         * @param {string} [orgUUID] organization uuid
         * @param {string} [userUUID] user uuid
         * @param {number} [size] size of returned data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getZodpovednyPredkladatelList(userFullNameContains?: string, orgUUID?: string, userUUID?: string, size?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PouzivatelPage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getZodpovednyPredkladatelList(userFullNameContains, orgUUID, userUUID, size, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PouzivatelListApi.getZodpovednyPredkladatelList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PouzivatelListApi - factory interface
 * @export
 */
export const PouzivatelListApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PouzivatelListApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [userUUID] user uuid
         * @param {string} [orgUUID] organization uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPouzivatelList(userUUID?: string, orgUUID?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<Pouzivatel>> {
            return localVarFp.getPouzivatelList(userUUID, orgUUID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [orgUUID] organization uuid
         * @param {string} [roleId] role id
         * @param {string} [userFullNameContains] user search name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPouzivatelWithRoleList(orgUUID?: string, roleId?: string, userFullNameContains?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<Pouzivatel>> {
            return localVarFp.getPouzivatelWithRoleList(orgUUID, roleId, userFullNameContains, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [userFullNameContains] user search name
         * @param {string} [orgUUID] organization uuid
         * @param {string} [userUUID] user uuid
         * @param {number} [size] size of returned data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getZodpovednyPredkladatelList(userFullNameContains?: string, orgUUID?: string, userUUID?: string, size?: number, options?: RawAxiosRequestConfig): AxiosPromise<PouzivatelPage> {
            return localVarFp.getZodpovednyPredkladatelList(userFullNameContains, orgUUID, userUUID, size, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PouzivatelListApi - object-oriented interface
 * @export
 * @class PouzivatelListApi
 * @extends {BaseAPI}
 */
export class PouzivatelListApi extends BaseAPI {
    /**
     * 
     * @param {string} [userUUID] user uuid
     * @param {string} [orgUUID] organization uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PouzivatelListApi
     */
    public getPouzivatelList(userUUID?: string, orgUUID?: string, options?: RawAxiosRequestConfig) {
        return PouzivatelListApiFp(this.configuration).getPouzivatelList(userUUID, orgUUID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [orgUUID] organization uuid
     * @param {string} [roleId] role id
     * @param {string} [userFullNameContains] user search name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PouzivatelListApi
     */
    public getPouzivatelWithRoleList(orgUUID?: string, roleId?: string, userFullNameContains?: string, options?: RawAxiosRequestConfig) {
        return PouzivatelListApiFp(this.configuration).getPouzivatelWithRoleList(orgUUID, roleId, userFullNameContains, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [userFullNameContains] user search name
     * @param {string} [orgUUID] organization uuid
     * @param {string} [userUUID] user uuid
     * @param {number} [size] size of returned data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PouzivatelListApi
     */
    public getZodpovednyPredkladatelList(userFullNameContains?: string, orgUUID?: string, userUUID?: string, size?: number, options?: RawAxiosRequestConfig) {
        return PouzivatelListApiFp(this.configuration).getZodpovednyPredkladatelList(userFullNameContains, orgUUID, userUUID, size, options).then((request) => request(this.axios, this.basePath));
    }
}



